var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-inner" }, [
    _c(
      "div",
      { staticClass: "form-card-wrapper" },
      [
        _c(
          "el-form",
          {
            ref: "basicForm",
            staticStyle: { display: "flex" },
            attrs: { "label-position": "left", "label-width": "90px" }
          },
          [
            _c("el-card", { staticClass: "form-card" }, [
              _c(
                "fieldset",
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.JobNo") } },
                    [
                      _c("el-input", {
                        attrs: { no: "1", disabled: _vm.viewStatus },
                        model: {
                          value: _vm.job.jobNo,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "jobNo", $$v)
                          },
                          expression: "job.jobNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Mbl2") } },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "50px" },
                            attrs: {
                              no: "2",
                              value: _vm.job.mbl.substring(0, 3),
                              disabled: _vm.viewStatus
                            }
                          }),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                "padding-right": "1.5px",
                                "padding-left": "1.5px"
                              }
                            },
                            [_vm._v("-")]
                          ),
                          _c("el-input", {
                            staticStyle: { flex: "1" },
                            attrs: {
                              no: "3",
                              value: _vm.job.mbl.substring(3),
                              disabled: _vm.viewStatus
                            }
                          }),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                "margin-left": "1px",
                                "padding-left": "10px",
                                "padding-right": "10px"
                              },
                              attrs: {
                                no: "4",
                                type: "primary",
                                disabled: _vm.viewStatus
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.PleaseSelect")))]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.LoadingPort") } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: {
                              width: "60px",
                              "margin-right": "5px"
                            },
                            attrs: { no: "5", disabled: _vm.viewStatus },
                            model: {
                              value: _vm.job.loadingPortCode,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "loadingPortCode", $$v)
                              },
                              expression: "job.loadingPortCode"
                            }
                          }),
                          _c("cargo-advance-select", {
                            staticStyle: { flex: "1" },
                            attrs: {
                              no: "6",
                              filterable: "",
                              disabled: _vm.viewStatus,
                              "select-type":
                                _vm.selectTypeNames.basic_data_Airport,
                              "callback-method-type": "value",
                              "default-value": _vm.job.loadingPortCode,
                              "callback-params": { key: "loadingPortCode" }
                            },
                            on: { parentCallBack: _vm.setJobSelectValue }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.PortOfDestination") } },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("el-input", {
                            staticStyle: {
                              width: "60px",
                              "margin-right": "5px"
                            },
                            attrs: { no: "7", disabled: _vm.viewStatus },
                            model: {
                              value: _vm.job.destinationPortCode,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "destinationPortCode", $$v)
                              },
                              expression: "job.destinationPortCode"
                            }
                          }),
                          _c("cargo-advance-select", {
                            staticStyle: { flex: "1" },
                            attrs: {
                              no: "8",
                              filterable: "",
                              disabled: _vm.viewStatus,
                              "select-type":
                                _vm.selectTypeNames.basic_data_Airport,
                              "callback-method-type": "value",
                              "default-value": _vm.job.destinationPortCode,
                              "callback-params": { key: "destinationPortCode" }
                            },
                            on: { parentCallBack: _vm.setJobSelectValue }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c("el-form-item", { attrs: { label: "" } }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between"
                        }
                      },
                      [
                        _c(
                          "el-checkbox",
                          {
                            attrs: { no: "9", disabled: _vm.viewStatus },
                            model: {
                              value: _vm.job.transfering,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "transfering", $$v)
                              },
                              expression: "job.transfering"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.Transit")))]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              no: "10",
                              disabled: _vm.viewStatus,
                              type: "primary"
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("SeaExport.EnterTransitInfo")))]
                        )
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("AirExport.CargoCollectionType") }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "98px" },
                            attrs: {
                              no: "11",
                              filterable: "",
                              disabled: _vm.viewStatus,
                              "select-type":
                                _vm.selectTypeNames.local_cache_CargoSource,
                              "callback-method-type": "value",
                              "default-value": _vm.job.cargoSource,
                              "callback-params": { key: "cargoSource" }
                            },
                            on: { parentCallBack: _vm.setJobSelectValue }
                          }),
                          _c("cargo-advance-select", {
                            staticStyle: { width: "98px" },
                            attrs: {
                              no: "12",
                              filterable: "",
                              disabled: _vm.viewStatus,
                              "select-type":
                                _vm.selectTypeNames.basic_data_CutomJobType,
                              "method-params": {
                                type: _vm.job.lob,
                                active: true
                              },
                              "callback-method-type": "value",
                              "default-value": _vm.job.customJobType,
                              "callback-params": { key: "customJobType" }
                            },
                            on: { parentCallBack: _vm.setJobSelectValue }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.DestinationAgent") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "13",
                          disabled: _vm.viewStatus,
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": { overseaAgent: true },
                          "callback-method-type": "value",
                          "default-value": _vm.job.destinationAgent || "",
                          "tag-name": "englishName",
                          "callback-params": { key: "destinationAgent" }
                        },
                        on: { parentCallBack: _vm.setJobSelectValue }
                      })
                    ],
                    1
                  ),
                  _vm.job.cargoSource === "NC"
                    ? _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.NominatedAgent") }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "14",
                              disabled: _vm.viewStatus,
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "method-params": { overseaAgent: true },
                              "callback-method-type": "value",
                              "default-value": _vm.job.designationAgent || "",
                              "tag-name": "englishName",
                              "callback-params": { key: "designationAgent" }
                            },
                            on: { parentCallBack: _vm.setJobSelectValue }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.BookingAgent") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "15",
                          disabled: _vm.viewStatus,
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": { bookingAgent: true },
                          "callback-method-type": "value",
                          "default-value": _vm.job.bookingAgent || "",
                          "callback-params": { key: "bookingAgent" }
                        },
                        on: { parentCallBack: _vm.setJobSelectValue }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.DocCutOffDate") } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "16",
                          disabled: _vm.viewStatus,
                          type: "date",
                          clearable: "",
                          format: "yyyy-MM-dd HH:mm",
                          "value-format": "yyyy-MM-dd HH:mm"
                        },
                        model: {
                          value: _vm.job.fileCutoff,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "fileCutoff", $$v)
                          },
                          expression: "job.fileCutoff"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.EnglishDescriptionOfGoods")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "17",
                          disabled: _vm.viewStatus,
                          type: "textarea",
                          rows: 5
                        },
                        model: {
                          value: _vm.job.cargoEnglishName,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "cargoEnglishName", $$v)
                          },
                          expression: "job.cargoEnglishName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c("el-card", { staticClass: "form-card" }, [
              _c("fieldset", [
                _c(
                  "div",
                  [
                    _c(
                      "el-form-item",
                      { staticClass: "custom", attrs: { label: "" } },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "12px",
                                  "font-weight": "normal",
                                  color: "#404144"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("SeaExport.Quantity")))]
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "12px",
                                  "font-weight": "normal",
                                  color: "#404144"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.Weight")) + "KGS"
                                )
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "12px",
                                  "font-weight": "normal",
                                  color: "#404144"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.Cubage")) + "CBM"
                                )
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "font-size": "12px",
                                  "font-weight": "normal",
                                  color: "#404144"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("SeaExport.ChargedWeight")) +
                                    "M/T"
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("AirExport.Commission") }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between"
                            }
                          },
                          [
                            _c("el-input-number", {
                              attrs: {
                                no: "18",
                                value:
                                  _vm.job.quantityContract === 0
                                    ? undefined
                                    : _vm.job.quantityContract,
                                disabled: _vm.viewStatus,
                                "controls-position": "right"
                              }
                            }),
                            _c("el-input-number", {
                              attrs: {
                                no: "19",
                                value:
                                  _vm.job.weightContract === 0
                                    ? undefined
                                    : _vm.job.weightContract,
                                disabled: _vm.viewStatus,
                                "controls-position": "right",
                                precision: 3
                              }
                            }),
                            _c("el-input-number", {
                              attrs: {
                                no: "20",
                                value:
                                  _vm.job.cubageContract === 0
                                    ? undefined
                                    : _vm.job.cubageContract,
                                disabled: _vm.viewStatus,
                                "controls-position": "right",
                                precision: 3
                              }
                            }),
                            _c("el-input-number", {
                              attrs: {
                                no: "21",
                                value:
                                  _vm.job.chargeWeight === 0
                                    ? undefined
                                    : _vm.job.chargeWeight,
                                disabled: _vm.viewStatus,
                                "controls-position": "right",
                                precision: 3
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.Booking") }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between"
                            }
                          },
                          [
                            _c("el-input-number", {
                              attrs: {
                                no: "22",
                                value:
                                  _vm.job.quantityBooking === 0
                                    ? undefined
                                    : _vm.job.quantityBooking,
                                disabled: _vm.viewStatus,
                                "controls-position": "right"
                              }
                            }),
                            _c("el-input-number", {
                              attrs: {
                                no: "23",
                                value:
                                  _vm.job.weightBooking === 0
                                    ? undefined
                                    : _vm.job.weightBooking,
                                disabled: _vm.viewStatus,
                                "controls-position": "right",
                                precision: 3
                              }
                            }),
                            _c("el-input-number", {
                              attrs: {
                                no: "24",
                                value:
                                  _vm.job.cubageBooking === 0
                                    ? undefined
                                    : _vm.job.cubageBooking,
                                disabled: _vm.viewStatus,
                                "controls-position": "right",
                                precision: 3
                              }
                            }),
                            _c("el-input-number", {
                              attrs: {
                                no: "25",
                                value:
                                  _vm.job.chargeWeightBooking === 0
                                    ? undefined
                                    : _vm.job.chargeWeightBooking,
                                disabled: _vm.viewStatus,
                                "controls-position": "right",
                                precision: 3
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.Actual") }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between"
                            }
                          },
                          [
                            _c("el-input-number", {
                              attrs: {
                                no: "26",
                                value:
                                  _vm.job.quantityActual === 0
                                    ? undefined
                                    : _vm.job.quantityActual,
                                disabled: _vm.viewStatus,
                                "controls-position": "right"
                              }
                            }),
                            _c("el-input-number", {
                              attrs: {
                                no: "27",
                                value:
                                  _vm.job.weightActual === 0
                                    ? undefined
                                    : _vm.job.weightActual,
                                disabled: _vm.viewStatus,
                                "controls-position": "right",
                                precision: 3
                              }
                            }),
                            _c("el-input-number", {
                              attrs: {
                                no: "28",
                                value:
                                  _vm.job.cubageActual === 0
                                    ? undefined
                                    : _vm.job.cubageActual,
                                disabled: _vm.viewStatus,
                                "controls-position": "right",
                                precision: 3
                              }
                            }),
                            _c("el-input-number", {
                              attrs: {
                                no: "29",
                                value:
                                  _vm.job.cWeight === 0
                                    ? undefined
                                    : _vm.job.cWeight,
                                disabled: _vm.viewStatus,
                                "controls-position": "right",
                                precision: 1
                              }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "custom",
                        attrs: { label: _vm.$t("SeaExport.Documentation") }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "justify-content": "space-between"
                            }
                          },
                          [
                            _c("el-input-number", {
                              attrs: {
                                no: "30",
                                value:
                                  _vm.cargoDoc.quantity === 0
                                    ? undefined
                                    : _vm.cargoDoc.quantity,
                                disabled: _vm.viewStatus,
                                "controls-position": "right"
                              }
                            }),
                            _c("el-input-number", {
                              attrs: {
                                no: "31",
                                value:
                                  _vm.cargoDoc.weight === 0
                                    ? undefined
                                    : _vm.cargoDoc.weight,
                                disabled: _vm.viewStatus,
                                "controls-position": "right",
                                precision: 3
                              }
                            }),
                            _c("el-input-number", {
                              attrs: {
                                no: "32",
                                value:
                                  _vm.cargoDoc.cubage === 0
                                    ? undefined
                                    : _vm.cargoDoc.cubage,
                                disabled: _vm.viewStatus,
                                "controls-position": "right",
                                precision: 3
                              }
                            }),
                            _c("el-input-number", {
                              attrs: {
                                no: "33",
                                value:
                                  _vm.cWeight == 0 ? undefined : _vm.cWeight,
                                disabled: _vm.viewStatus,
                                "controls-position": "right",
                                precision: 1
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c("div", { staticStyle: { display: "flex" } }, [
                  _c(
                    "div",
                    {
                      staticStyle: { "margin-right": "20px", "flex-grow": "1" }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.AirlineCompany") }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "34",
                              disabled: _vm.viewStatus,
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "method-params": { airCmp: true },
                              "callback-method-type": "value",
                              "default-value": _vm.job.carrierId || "",
                              "callback-params": { key: "carrierId" }
                            },
                            on: { parentCallBack: _vm.setJobSelectValue }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Flight") } },
                        [
                          _c("el-input", {
                            attrs: { no: "35", disabled: _vm.viewStatus },
                            model: {
                              value: _vm.job.voyageFlight,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "voyageFlight", $$v)
                              },
                              expression: "job.voyageFlight"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.OperationDate") } },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              no: "36",
                              disabled: _vm.viewStatus,
                              type: "date",
                              clearable: ""
                            },
                            model: {
                              value: _vm.job.customsDate,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "customsDate", $$v)
                              },
                              expression: "job.customsDate"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.DateOfDeparture") }
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              no: "37",
                              disabled: _vm.viewStatus,
                              type: "date",
                              clearable: ""
                            },
                            model: {
                              value: _vm.job.etd,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "etd", $$v)
                              },
                              expression: "job.etd"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.DateOfArrival") } },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              no: "38",
                              disabled: _vm.viewStatus,
                              type: "date",
                              clearable: ""
                            },
                            model: {
                              value: _vm.job.ETA,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "ETA", $$v)
                              },
                              expression: "job.ETA"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Marks") } },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "39",
                              disabled: _vm.viewStatus,
                              type: "textarea",
                              rows: 5
                            },
                            model: {
                              value: _vm.job.mark,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "mark", $$v)
                              },
                              expression: "job.mark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { "flex-grow": "1" } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SeaExport.MasterBLFreightTerm")
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "40",
                              filterable: "",
                              disabled: _vm.viewStatus,
                              "select-type":
                                _vm.selectTypeNames.basic_data_PaymentTerm,
                              "callback-method-type": "value",
                              "default-value": _vm.job.paymentTermMBL,
                              "callback-params": { key: "paymentTermMBL" }
                            },
                            on: { parentCallBack: _vm.setJobSelectValue }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.BookingProperty") }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "41",
                              filterable: "",
                              disabled: _vm.viewStatus,
                              "select-type":
                                _vm.selectTypeNames.local_cache_BookingTerm,
                              "callback-method-type": "value",
                              "default-value": _vm.job.bookingTerm,
                              "callback-params": { key: "bookingTerm" }
                            },
                            on: { parentCallBack: _vm.setJobSelectValue }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.CargoType") } },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "42",
                              filterable: "",
                              disabled: _vm.viewStatus,
                              "select-type":
                                _vm.selectTypeNames.basic_data_CargoType,
                              "callback-method-type": "value",
                              "default-value": _vm.job.cargoType,
                              "callback-params": { key: "cargoType" }
                            },
                            on: { parentCallBack: _vm.setJobSelectValue }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Package") } },
                        [
                          _c("cargo-packing-select", {
                            attrs: {
                              no: "43",
                              "default-value": _vm.job.packing,
                              "callback-params": {}
                            },
                            on: {
                              change: function(p) {
                                p.key = "packing"
                                _vm.setJobSelectValue(p)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.AdditionalNotes") }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              no: "44",
                              disabled: _vm.viewStatus,
                              type: "textarea",
                              rows: 5
                            },
                            model: {
                              value: _vm.job.remarks,
                              callback: function($$v) {
                                _vm.$set(_vm.job, "remarks", $$v)
                              },
                              expression: "job.remarks"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ])
            ]),
            _c("el-card", { staticClass: "form-card" }, [
              _c(
                "fieldset",
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.TradeMethod") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "45",
                          filterable: "",
                          disabled: _vm.viewStatus,
                          "select-type":
                            _vm.selectTypeNames.basic_data_TradeTerm,
                          "callback-method-type": "value",
                          "default-value": _vm.job.tradeTerm,
                          "callback-params": { key: "tradeTerm" }
                        },
                        on: { parentCallBack: _vm.setJobSelectValue }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Documents") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "46",
                          filterable: "",
                          disabled: _vm.viewStatus,
                          "select-type": _vm.selectTypeNames.basic_data_User,
                          "callback-method-type": "value",
                          "default-value": _vm.job.dc == 0 ? "" : _vm.job.dc,
                          "callback-params": { key: "dc" }
                        },
                        on: { parentCallBack: _vm.setJobSelectValue }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.AirlinePerson2") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "47",
                          filterable: "",
                          disabled: _vm.viewStatus,
                          "select-type": _vm.selectTypeNames.basic_data_User,
                          "callback-method-type": "value",
                          "default-value":
                            _vm.job.planner == 0 ? "" : _vm.job.planner,
                          "callback-params": { key: "planner" }
                        },
                        on: { parentCallBack: _vm.setJobSelectValue }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.FieldOperation") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "48",
                          filterable: "",
                          disabled: _vm.viewStatus,
                          "select-type": _vm.selectTypeNames.basic_data_User,
                          "callback-method-type": "value",
                          "default-value":
                            _vm.job.siteOP == 0 ? "" : _vm.job.siteOP,
                          "callback-params": { key: "siteOP" }
                        },
                        on: { parentCallBack: _vm.setJobSelectValue }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.SalesOfGoods") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "49",
                          filterable: "",
                          disabled: _vm.viewStatus,
                          "select-type": _vm.selectTypeNames.basic_data_User,
                          "callback-method-type": "value",
                          "default-value":
                            _vm.job.cargoSalesId == 0
                              ? ""
                              : _vm.job.cargoSalesId,
                          "callback-params": { key: "cargoSalesId" }
                        },
                        on: { parentCallBack: _vm.setJobSelectValue }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.OperationCompany") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "50",
                          disabled: _vm.viewStatus,
                          "select-type": _vm.selectTypeNames.basic_data_Office,
                          filterable: "",
                          "callback-params": { key: "opOffice" },
                          "callback-method-type": "value",
                          "default-value": _vm.job.opOffice
                        },
                        on: { parentCallBack: _vm.setJobSelectValue }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.OperationDepartment") }
                    },
                    [
                      _c("cargo-department-select", {
                        attrs: {
                          no: "51",
                          disabled: _vm.viewStatus,
                          "office-id": Number(_vm.job.opOffice),
                          "department-id": Number(_vm.job.opDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.job.opDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Operation") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "52",
                          filterable: "",
                          disabled: _vm.viewStatus,
                          "select-type": _vm.selectTypeNames.basic_data_User,
                          "callback-method-type": "value",
                          "default-value": _vm.job.op == 0 ? "" : _vm.job.op,
                          "callback-params": { key: "op" }
                        },
                        on: { parentCallBack: _vm.setJobSelectValue }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Payment.customerService") } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "53",
                          filterable: "",
                          disabled: _vm.viewStatus,
                          "select-type": _vm.selectTypeNames.basic_data_User,
                          "callback-method-type": "value",
                          "default-value": _vm.job.csr == 0 ? "" : _vm.job.csr,
                          "callback-params": { key: "csr" }
                        },
                        on: { parentCallBack: _vm.setJobSelectValue }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isAddUserDefinedRoles,
                          expression: "isAddUserDefinedRoles"
                        }
                      ],
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_userDefinedRole1")
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId1",
                        attrs: {
                          no: "userDefinedRoleId1",
                          disabled: _vm.viewStatus,
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole1"
                          },
                          "default-value": _vm.job.userDefinedRoleId1 || "",
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleId1Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isAddUserDefinedRoles,
                          expression: "isAddUserDefinedRoles"
                        }
                      ],
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_userDefinedRole2")
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "userDefinedRoleId2",
                        attrs: {
                          no: "userDefinedRoleId2",
                          disabled: _vm.viewStatus,
                          "method-params": {
                            officeId: _vm.$store.getters.currentOfficeId,
                            category: "role",
                            shape: "userDefinedRole2"
                          },
                          "default-value": _vm.job.userDefinedRoleId2 || "",
                          "merge-load": true
                        },
                        on: {
                          change: function(p) {
                            _vm.pm.userDefinedRoleId2Handler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _c("el-card", { staticClass: "form-card" }, [
              _c(
                "fieldset",
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.UserDefinedField1") } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "54",
                          disabled: _vm.viewStatus,
                          type: "textarea",
                          rows: 5
                        },
                        model: {
                          value: _vm.job.userDefinedField1,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "userDefinedField1", $$v)
                          },
                          expression: "job.userDefinedField1"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.UserDefinedField2") } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "55",
                          disabled: _vm.viewStatus,
                          type: "textarea",
                          rows: 5
                        },
                        model: {
                          value: _vm.job.userDefinedField2,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "userDefinedField2", $$v)
                          },
                          expression: "job.userDefinedField2"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.UserDefinedField3") } },
                    [
                      _c("el-input", {
                        attrs: {
                          no: "56",
                          disabled: _vm.viewStatus,
                          type: "textarea",
                          rows: 5
                        },
                        model: {
                          value: _vm.job.userDefinedField3,
                          callback: function($$v) {
                            _vm.$set(_vm.job, "userDefinedField3", $$v)
                          },
                          expression: "job.userDefinedField3"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "form-card-wrapper",
        staticStyle: { "flex-direction": "row", width: "100%" }
      },
      [
        _c(
          "el-card",
          { staticClass: "form-card", staticStyle: { flex: "1" } },
          [
            _c("fieldset", [
              _c("legend", [_vm._v(_vm._s(_vm.$t("SeaExport.TicketsInfo")))]),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-end"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "triggers",
                      staticStyle: { "margin-bottom": "5px" }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("SeaExport.TotalTickets")) + ":")
                      ]),
                      _c("span", { staticStyle: { "margin-right": "5px" } }, [
                        _vm._v(_vm._s(_vm.job.lclSlaves.length || 0))
                      ]),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "57",
                            type: "primary",
                            disabled:
                              _vm.viewStatus ||
                              _vm.viewSource === "financeDetail" ||
                              _vm.viewSource === "salesDetail"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.NewTickets")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "58",
                            type: "primary",
                            disabled:
                              _vm.viewStatus ||
                              _vm.viewSource === "financeDetail" ||
                              _vm.viewSource === "salesDetail"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.EditTickets")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "59",
                            type: "primary",
                            disabled:
                              _vm.viewStatus ||
                              _vm.viewSource === "financeDetail" ||
                              _vm.viewSource === "salesDetail"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.AddTickets")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            no: "60",
                            type: "danger",
                            disabled:
                              _vm.viewStatus ||
                              _vm.viewSource === "financeDetail" ||
                              _vm.viewSource === "salesDetail"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.RemoveTickets")))]
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    "min-height": "200px",
                    "flex-direction": "column"
                  }
                },
                [
                  _c("cargo-ag-grid", {
                    staticStyle: { height: "300px", width: "100%" },
                    attrs: {
                      "config-module": "150007",
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.job.lclSlaves || []
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.gridApi = params.api
                      }
                    }
                  })
                ],
                1
              )
            ])
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }